module.exports = __webpack_public_path__ + "static/media/m3pred.084edb74.png";